import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { photos } from '../../data/site';
import { ButtonLink } from '../ui/ButtonLink';
import { Container } from '../ui/Container';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  const reduce = useReducedMotion();
  const enter = (delay: number) => reduce ? {} : {
    initial: {
      opacity: 0,
      y: 14
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      ease,
      delay
    }
  };
  return <section id="top" aria-labelledby="hero-title" className="bates-hero on-dark relative isolate overflow-hidden bg-ink text-white" data-id="element-129" data-mp="5nvx9hzlhhq4">
      <img src={photos.clubGroup} alt="A large group of children, teens and adults together at Bates Taekwondo" className="bates-hero-photo absolute inset-x-0 bottom-0 w-full" fetchPriority="high" data-id="element-130" data-mp="3rwoqxs68kbbk" />
      <div className="bates-hero-shade absolute inset-0" aria-hidden="true" data-id="element-131" data-mp="1q525e65458mh" />
      <Container className="relative z-10 pt-12 text-center sm:pt-14 lg:pt-8" data-id="element-132" data-mp="1mwm1pyy9nq5y">
        <div className="mx-auto max-w-[980px]" data-id="element-133" data-mp="1myozx69koplr">
          <motion.p {...enter(0)} className="font-display text-[15px] font-semibold uppercase tracking-[0.18em] text-white/90" data-id="element-134" data-mp="1rwgwwep2r1wt">
            Taekwondo in Albuquerque
          </motion.p>
          <motion.h1 {...enter(0.05)} id="hero-title" className="text-balance mt-4 font-display text-[3.15rem] font-bold uppercase leading-[0.94] tracking-[-0.01em] sm:text-[4.25rem] lg:text-[4.4rem]" data-id="element-135" data-mp="1hwg8iecclvlr">
            Big confidence starts with <span className="text-[#FF6268]" data-id="element-136" data-mp="1vxagivvhhujw">one small step.</span>
          </motion.h1>
          <motion.p {...enter(0.1)} className="text-pretty mx-auto mt-5 max-w-[900px] text-[1.025rem] leading-relaxed text-white/90 sm:text-lg" data-id="element-137" data-mp="20w3xiy9zc3ot">
            At Bates Taekwondo, children, teens and adults get personal coaching, positive challenges they can actually
            meet, and a place where they belong. Come try a class and see how it feels.
          </motion.p>
          <motion.div {...enter(0.15)} className="mt-7 flex flex-col justify-center gap-3 sm:flex-row sm:flex-wrap" data-id="element-138" data-mp="337ls6ud14kor">
            <ButtonLink href="#first-class" data-id="element-139" data-mp="2y7he1azlg21p">Book a Free Trial Class</ButtonLink>
            <ButtonLink href="#programs" variant="outlineLight" className="bg-black/60" icon={<ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-141" data-mp="2p7ubglv4oq72" />} data-id="element-140" data-mp="2u5vtr4kqclhh">
              Explore Programs
            </ButtonLink>
          </motion.div>
        </div>
      </Container>
    </section>;
}